<div class="cookie-consent-banner" *ngIf="showBanner">
  <div class="cookie-consent-content">
    <div class="cookie-consent-text">
      <h3>{{ t.CookieConsentTitle }}</h3>
      <p>
        {{ t.CookieConsentMessage }}
      </p>
      <p class="cookie-consent-small">
        {{ t.CookieConsentDetails }}
      </p>
    </div>
    <div class="cookie-consent-actions">
      <button
        class="cookie-consent-btn cookie-consent-btn-accept"
        (click)="onAccept()"
        [attr.aria-label]="t.CookieConsentAccept">
        {{ t.CookieConsentAccept }}
      </button>
      <button
        class="cookie-consent-btn cookie-consent-btn-decline"
        (click)="onDecline()"
        [attr.aria-label]="t.CookieConsentDecline">
        {{ t.CookieConsentDecline }}
      </button>
    </div>
  </div>
</div>

